// Reveals DOM elements when they reach the viewport.
const handleReveal = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('reveal');
      observer.unobserve(entry.target);
    }
  });
};

const initObserver = () => {
  const targets = document.querySelectorAll('[data-observe]');

  if (targets.length) {
    const observer = new IntersectionObserver(handleReveal, {
      threshold: 0.07,
    });

    targets.forEach((target) => {
      observer.observe(target);
    });
  }
};

(() => {
  initObserver();
})();

export default initObserver;
